export default __webpack_public_path__ + "static/media/M1.0b6b6c80.svg";